import { Card, CardBody, Col, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { Href, NextData, PaginationWithIcon } from "../../../../Utils/Constants";
import { iconPaginationData } from "../../../../Data/BonusUi/Pagination/Pagination";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";

const PaginationWithIcons = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CardHeaderCommon
          title={PaginationWithIcon}
          span={iconPaginationData}
        />
        <CardBody>
          <Pagination
            className="pagination-secondary pagin-border-secondary mb-3"
            aria-label="Page navigation example"
          >
            <PaginationItem>
              <PaginationLink href={Href} first></PaginationLink>
            </PaginationItem>
            {NextData.map((item, index) => (
              <PaginationItem key={index}>
                <PaginationLink href={Href}>{item}</PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem>
              <PaginationLink href={Href} last></PaginationLink>
            </PaginationItem>
          </Pagination>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PaginationWithIcons;
